import { create } from "zustand";

export type IDataMetodoPago = {
  metodo: string;
  valor: string;
}
type useMetodoPagoPagoProps = {
  metodoPago: IDataMetodoPago[];
  handleMetodoPagoLista: (metodoPago: IDataMetodoPago[]) => void;
  clearMetodoPago:()=>void
}
export const useMetodoPago = create<useMetodoPagoPagoProps>((set) => ({
  metodoPago: [],

  //Guardar una nueva lista
  handleMetodoPagoLista: (metodoPago) => {
    set({ metodoPago: metodoPago })
  },
  //Liampiamos
   clearMetodoPago:()=>{
    set({metodoPago: []})
  },
 
})); 